/* eslint-disable indent */
import { dom } from 'utils'
import dayjs from 'dayjs'

function isExisted(comp) {
    if(Array.isArray(comp)) {
        return comp.length > 0
    }

    return comp
}

export default {
    data () {
        const advise = this.$parent.advise
        return {
            form: null,
            advise: this.getAdviseValue(advise),
            insertUrl: '/evaluation/insert.api',
            updateUrl: '/evaluation/update.api',
            errorMsg: {
                content: '综合评价不能为空',
                userViewpoint: '评价意见不能为空',
                grade: '建议定级不能为空',
                score: '评分标准不能为空',
                monthBaseSalary: '月基本薪资不能为空',
                monthCount: '薪资一年发放月份不能为空',
                expectSalary: '期望薪资不能为空',
                interviewRecord: '面试记录不能为空',
                adviceSalary: '建议薪资不能为空',
                hireAdvice: '岗位建议方向不能为空',
                otherWelfare: '其他福利说明不能为空',
                lastEntryTime: '最快到岗时间不能为空',
                comCommunication: '请选择“综合能力-沟通表达”评分',
                comLogical: '请选择“综合能力-逻辑思维”评分',
                comLearning: '请选择“综合能力-学习能力”评分',
                comCrush: '请选择“综合能力-抗压力”评分',
                comExecutive: '请选择“综合能力-执行力”评分',
                comStrain: '请选择“综合能力-应变”评分',
                perAffinity: '请选择“个人素质-亲和力”评分',
                perSolid: '请选择“个人素质-踏实度”评分',
                perExtroversion: '请选择“个人素质-外向性”评分',
                otherRecognition: '其他-热爱度与平台认可度不能为空',
                otherCareerPlan: '其他-职业规划不能为空',
                otherFamilyInfo: '其他-家庭情况不能为空',
                professionalProjMgr: '专业能力-项目管理不能为空',
                professionalArt: '专业能力-美术背景不能为空'
            }
        }
    },
    created () {
    },
    methods: {
        setForm (initForm) {
            for (let name in this.form) {
                this.form[name] = initForm[name]
            }
            let advice = initForm.hireAdvice && this.getAdviseValue(initForm.hireAdvice)
            let realAdvice = []
            // 修正错误的旧数据
            this.advise.forEach(item => {
                if (advice.indexOf(item) > -1) {
                    realAdvice.push(item)
                }
            })
            if (realAdvice.length > 0) {
                this.form.hireAdvice = realAdvice
            }
            this.form.hireAdvice = this.form.hireAdvice || []
            this.form.userViewpoint = String(initForm.userViewpoint)
            initForm.id && (this.form.id = String(initForm.id))
        },
        getAdviseValue (advise) {
            let splitUnit = ','
            if (advise && advise.indexOf('、') > -1) {
                splitUnit = '、'
            }
            let adviseArr = advise === '' || advise === undefined ? [] : advise.split(splitUnit)
            return adviseArr
        },
        checkData () {
            let pass = true
            let firstName = ''
            let message = ''
            let salaryList = [ 'grade', 'monthBaseSalary', 'monthCount', 'otherWelfare', 'adviceSalary', 'expectSalary' ]
            for (let name in this.form) {
                if (name === 'hireAdvice' && (this.advise.length === 0 || ['11', '12', '13', '14', '15', '16'].includes(this.scoreType))) {
                    continue
                }
                if ((salaryList.includes(name)) && (this.form.userViewpoint === '3' || this.form.userViewpoint === '4')) {
                    continue
                }
                if (name === 'otherInfo') continue

                if (name !== 'id' &&
                    (typeof this.form[name] === 'string' && this.form[name].trim() === '' || typeof this.form[name] === 'undefined') &&
                    isExisted(this.$refs[name])
                ) {
                    pass = false
                    firstName = name
                    message = this.errorMsg[name] || '表单不能为空'
                    if (name === 'professionalProjMgr' && this.scoreType === '12') {
                        message = '专业能力不能为空'
                    }
                    break
                } else if (name !== 'id' && this.form[name] instanceof Array && this.form[name].length === 0) {
                    pass = false
                    firstName = name
                    message = this.errorMsg[name] || '表单不能为空'
                    break
                } else if (this.formValidator && this.formValidator[name]) {
                    let result = this.formValidator[name](this.form[name].trim())
                    if (result) {
                        message = result
                        pass = false
                        firstName = name
                        break
                    }
                }
            }
            if (!pass) {
                this.$message({
                    message: message,
                    type: 'warning'
                })
                let view = this.$refs[firstName]
                if(Array.isArray(view)) view = view[0]
                let childArr = view.$el.children || view.$el.childNodes
                this.blinkFormItemContent(view.type && view.type === 'textarea' ? childArr[0] : view.$el.parentElement)
            }
            return pass
        },
        blinkFormItemContent ($el) {
            let Timer = null,
                i = 0,
                that = this
            window.scrollTo(0, dom.offset($el).top - 160)
            Timer = setInterval(function () {
                i = i + 1
                i === 6 ? clearInterval(Timer) : (i % 2 === 0 ? ($el.style.backgroundColor = '#ffd4d4') : ($el.style.backgroundColor = '#fff'))
            }, 120)
        },
        submit () {
            if (this.checkData()) {
                this.$axios.post(this.isEdit ? this.updateUrl : this.insertUrl, Object.assign({}, this.form, {
                    lastEntryTime: this.form.lastEntryTime ? dayjs(this.form.lastEntryTime).format('YYYY-MM-DD') : '',
                    hireAdvice: this.form.hireAdvice instanceof Array ? this.form.hireAdvice.join('、') : '',
                    resumePositionId: this.$route.params.id
                }, this.extInfo || {}), {'X-showMessage': true}).then(res => {
                    this.$emit('refresh')
                })
            }
        },
        cancel () {
            this.$emit('cancel')
        }
    },
    computed: {
        viewPointOptions () {
            return this.selectMap ? this.selectMap['WB_USER_VIEWPOINT'] : []
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/evaluation/society-form/society-form-base.js